import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core"; import { Location } from "@angular/common";

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { AttributEntite } from '../entites/attribut';
import { AttributCategorieEntite } from '../entites/attribut-categorie';

@Injectable({ providedIn: 'root' })
export class AttributService {

  private obtenirListeUrl = environment.apiBaseUrl + 'attribut';
  private obtenirUrl = environment.apiBaseUrl + 'attribut/{id}';
  private obtenirLiensUrl = environment.apiBaseUrl + 'attribut/liens/{id}';
  private ajouterUrl = environment.apiBaseUrl + 'attribut';
  private modifierUrl = environment.apiBaseUrl + 'attribut/modifier';
  private modifierLiensUrl = environment.apiBaseUrl + 'attribut/liens/{attributId}';
  private supprimerUrl = environment.apiBaseUrl + 'attribut/{id}';


  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router) { }

  public ObtenirListe(): Promise<ReponseBase<AttributEntite[]>> {
    var p = this.http.get<ReponseBase<AttributEntite[]>>(this.obtenirListeUrl)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Obtenir(id: number): Promise<ReponseBase<AttributEntite>> {
    var p = this.http.get<ReponseBase<AttributEntite>>(this.obtenirUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public ObtenirLiens(id: number): Promise<ReponseBase<AttributCategorieEntite[]>> {
    var p = this.http.get<ReponseBase<AttributCategorieEntite[]>>(this.obtenirLiensUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Ajouter(attribut: AttributEntite): Promise<ReponseBase<AttributEntite>> {
    var p = this.http.post<ReponseBase<AttributEntite>>(this.ajouterUrl, JSON.stringify(attribut), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Modifier(attribut: AttributEntite): Promise<ReponseBase<AttributEntite>> {
    var p = this.http.post<ReponseBase<AttributEntite>>(this.modifierUrl, JSON.stringify(attribut), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public ModifierLiens(attributId: number, attributsCategories: AttributCategorieEntite[]): Promise<ReponseBase<number>> {
    var p = this.http.post<ReponseBase<number>>(this.modifierLiensUrl.replace('{attributId}', attributId.toString()), JSON.stringify(attributsCategories), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Supprimer(id: number): Promise<ReponseBase<number>> {
    var p = this.http.delete<ReponseBase<number>>(this.supprimerUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      this.log(`${operation} failed: ${error.message}`);

      this.router.navigateByUrl('erreurtechnique');

      return of(result as T);
    };
  }

  private log(message: string) {
    console.log(message);
  }
}
